import {
  MoreVert,
  ToggleOffOutlined,
  ToggleOnOutlined,
} from '@mui/icons-material';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import React, { FC, MouseEvent, useState } from 'react';
import { EditSquareOutlinedIcon } from '../../../../../assets/icons';
import { Constancia } from '../../../../../utils/models';

interface Props {
  certificate: Constancia;
  onEdit: () => void;
  onChangeStatus: () => void;
}

export const CertificateTableActions: FC<Props> = ({
  certificate,
  onEdit,
  onChangeStatus,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    onEdit();
    handleClose();
  };

  const handleChangeStatus = () => {
    onChangeStatus();
    handleClose();
  };

  return (
    <Box>
      <IconButton
        aria-label="more"
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{ p: 0.5 }}>
        <MoreVert />
      </IconButton>
      <Menu
        variant="menu"
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        anchorPosition={{ top: 0, left: 0 }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}>
        <MenuItem onClick={handleEdit}>
          <ListItemIcon>
            <EditSquareOutlinedIcon />
          </ListItemIcon>
          <ListItemText primary="Editar" />
        </MenuItem>
        <MenuItem onClick={handleChangeStatus}>
          <ListItemIcon>
            {certificate.activo ? (
              <ToggleOffOutlined sx={{ color: 'secondary.main' }} />
            ) : (
              <ToggleOnOutlined sx={{ color: 'secondary.main' }} />
            )}
          </ListItemIcon>
          <ListItemText
            primary={certificate.activo ? 'Desactivar' : 'Activar'}
          />
        </MenuItem>
      </Menu>
    </Box>
  );
};
